import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';

@Component({
  selector: 'dispatch-assignment-history',
  templateUrl: './dispatch-assignment-history.component.html',
  styleUrls: ['./dispatch-assignment-history.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchAssignmentHistoryComponent extends BaseGridUIComponent<v_DispatchAssignmentBus, null, DispatchesService>  {

    dispatchAssignmentStatusFC: MSFilterClass = new MSFilterClass('dispatchAssignmentStatusName');

    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
    }
    //id = dispatchAssignmentId
    reAssign(id: any) {
        this.sendParentMessage(MessageType.reassignTech, null, null, id);
    }
  //rowSelected(e: SelectionEvent) {
  //  this.selectedData = e.selectedRows[0].dataItem;
  //}
}
